import React, { useEffect, useState } from 'react';

export default function IntroLoader() {
  const [reduceMotion, setReduceMotion] = useState(false);
  const [visible, setVisible] = useState(() => {
    try {
      return window.sessionStorage.getItem('pshr-portfolio-intro') !== 'seen';
    } catch {
      return true;
    }
  });
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setReduceMotion(media.matches);
    update();
    media.addEventListener?.('change', update);
    return () => media.removeEventListener?.('change', update);
  }, []);

  useEffect(() => {
    if (!visible) return undefined;
    const closeTimer = window.setTimeout(() => {
      try {
        window.sessionStorage.setItem('pshr-portfolio-intro', 'seen');
      } catch {
        // Storage access is optional for this visual enhancement.
      }
      setClosing(true);
    // Keep the field-note flourish, but do not hold meaningful first-paint
    // content behind it for nearly a second on a fresh visit.
    }, reduceMotion ? 60 : 220);
    const removeTimer = window.setTimeout(() => setVisible(false), reduceMotion ? 110 : 520);
    return () => {
      window.clearTimeout(closeTimer);
      window.clearTimeout(removeTimer);
    };
  }, [reduceMotion, visible]);

  if (!visible) return null;

  return (
    <div className={`intro-loader ${closing ? 'is-closing' : ''} ${reduceMotion ? 'intro-loader--reduced' : ''}`} aria-label="Opening portfolio" role="status">
      <div className="intro-loader__panel">
        <div className="intro-loader__mark">PSHR</div>
        <div className="intro-loader__copy">
          <span>Putha Sri Hari Reddy</span>
          <small>Independent product field notes</small>
        </div>
        <div className="intro-loader__line" />
      </div>
    </div>
  );
}
